export interface ImageData {
  imageUrl: string;
  thumbUrl?: string;
  classes?: string;
}

/** AVILLAS IMAGE */
export const avillasSm: ImageData = {
  imageUrl: 'assets/images/illustrations/avilas-sm.png',
  classes: 'avillas-sm',
};

export const avillasLg: ImageData = {
  imageUrl: 'assets/images/illustrations/avilas-lg.jpg',
  classes: 'avillas-lg',
};

/** GET APPROVED ILLUSTRATION */
export const getApprovedDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/get-approved-desktop.png',
  classes: 'get-approved-desktop',
};

export const getApprovedMobile: ImageData = {
  imageUrl: 'assets/images/illustrations/get-approved-mobile.png',
};

/** SECURE SITE UPLOAD SUCCESS ILLUSTRATION */
export const congratsMobile: ImageData = {
  imageUrl: 'assets/images/illustrations/congrats-mobile.svg',
  classes: 'congrats-mobile',
};

export const congratsDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/congrats-desktop.svg',
  classes: 'congrats-desktop',
};

/** ELIGIBILITY SUCCESS ILLUSTRATION */
export const congratsManMobile: ImageData = {
  imageUrl: 'assets/images/illustrations/congrats-man-mobile.svg',
  classes: 'congrats-man-mobile',
};

export const congratsManDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/congrats-man@2x.png',
  classes: 'congrats-man-desktop',
};

/** SECURE SITE MAIN ILLUSTRATION */
export const pairDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/pair-desktop.svg',
  classes: 'pair-desktop',
};

/** SECURE SITE LOGIN ILLUSTRATION */
export const doorDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/door.svg',
  classes: 'door-desktop',
};

/** CALCULATOR ILLUSTRATION */
export const calculatorLandingDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/calculator-landing-desktop.svg',
  classes: 'calculator-landing-desktop',
};

export const calculatorEligibleDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/calculator-eligible-desktop.svg',
  classes: 'calculator-eligible-desktop',
};

export const calculatorNotEligibleDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/calculator-not-eligible-desktop.svg',
  classes: 'calculator-not-eligible-desktop',
};
/** Prequalification Calculator Illustrations */
export const estimatedCostsSuccessDesktop: ImageData = {
  imageUrl: 'assets/images/illustrations/estimated-costs-success-desktop.svg',
  classes: 'estimated-costs-desktop',
};

export const estimatedCostsSuccessMobile: ImageData = {
  imageUrl: 'assets/images/illustrations/estimated-costs-success-mobile.svg',
  classes: 'estimated-costs-mobile',
};

// COMMERCIAL PREQUALIFICATION IMAGES
export const commercialEligibilityDesktop: ImageData = {
  imageUrl: 'assets/images/commercial-eligibility.jpg',
  classes: 'commercial-eligibility-desktop',
};

export const commercialEligibilityMobile: ImageData = {
  imageUrl: 'assets/images/commercial-eligibility.jpg',
  classes: 'commercial-eligibility-mobile',
};

export const commercialSuccessDesktop: ImageData = {
  imageUrl: 'assets/images/commercial-success.jpg',
  classes: 'commercial-success-desktop',
};

export const commercialSuccessMobile: ImageData = {
  imageUrl: 'assets/images/commercial-success.jpg',
  classes: 'commercial-success-mobile',
};
